const prefix = {
    user: '/u',
    dashboard: '/painel'
};

const paths = {
    // onboarding
    login: '/entrar',
    register: '/cadastrar',
    recoverAccount: '/recuperar-conta',  
    
    home: '/',

    checkin: '/checkin',
    
    events: {
        page: '/evento',
        home: '/eventos',
        trendboard: '/eventos-em-alta',
        listing: (citySlug) => `/eventos/${citySlug}`,
        establishment: (eventSlug, establishmentSlug) => `/evento/${eventSlug}/estabelecimento/${establishmentSlug}`,
        search: '/eventos/buscar',
    },

    partner: {
        createAccount: '/quero-ser-parceiro'
    },

    producer: {
        page: '/produtor',
    },

    establishments: {
        page: '/estabelecimento',
        home: '/estabelecimentos',
        trendboard: '/eventos-em-alta',
        listing: (citySlug) => `/estabelecimentos/${citySlug}`,
        search: '/estabelecimentos/buscar',
    },
    
    user: {
        profile: '/perfil',
        // following: `${prefix.user}/:user/seguindo`,
        // followers: `${prefix.user}/:user/seguidores`,
        wallet: `/carteira`,
    },

    checkout: {
        orders: '/checkout'
    },

    dashboard: {
        home: `${prefix.dashboard}/perfil`,
        profile: `${prefix.dashboard}/perfil`,
        resume: `${prefix.dashboard}/resumo`,
        products: `${prefix.dashboard}/produtos`,
        events: `${prefix.dashboard}/eventos`,
        financial: `${prefix.dashboard}/financeiro`,
        support: `${prefix.dashboard}/suporte`,
        checkin: `${prefix.dashboard}/checkin`,
        orders: `${prefix.dashboard}/pedidos`,
        orders_establishment: `${prefix.dashboard}/pdv`,
        statistics: `${prefix.dashboard}/estatisticas`,
        restaurant: {
            menu:           `${prefix.dashboard}/restaurante/cardapio`,
            posEvents:      `${prefix.dashboard}/restaurante/eventos`,
            kitchen:        `${prefix.dashboard}/restaurante/cozinha`,
            waiter:         `${prefix.dashboard}/restaurante/comandas`,
            admin:          `${prefix.dashboard}/restaurante/administracao`,
            statistics:     `${prefix.dashboard}/restaurante/estatisticas`,
            cashier:        `${prefix.dashboard}/restaurante/caixa`,
            cashierSession: (id) => `${prefix.dashboard}/restaurante/caixa/${id}`,
            customers:      `${prefix.dashboard}/restaurante/clientes`,
            promotions:     `${prefix.dashboard}/restaurante/promocoes`,
        },
    },

    restaurant: {
        publicMenu:  '/:slug/menu',
        waiterApp:   '/:slug/garcom',
        stationApp:  '/:slug/estacao/:stationSlug',
    },

    otp: {
        login: '/acesso',
    },

    terms: {
        useTerms: '/termos-de-uso',
        policiePrivacy: '/politica-de-privacidade',
        policiePrivacyPDV: '/politica-de-privacidade-pdv',
    },

    contact: '/contato'
};


export default paths;                   